import { convertToStoryblokCdn } from '../pipes/storyblok-cdn.pipe';

export const convertToOgImageUrl = (imageUrl: string, storyblokUrl: string): string => {
  if (!imageUrl) return;
  imageUrl = convertToStoryblokCdn(imageUrl, storyblokUrl);
  if (!imageUrl.includes(storyblokUrl)) return imageUrl;
  if (imageUrl.endsWith('.svg')) {
    return `${imageUrl}/m/1200x0/filters:format(jpg)`;
  }
  return `${imageUrl}/m/1200x0`;
};
